//export const baseUrl = 'http://localhost';
//export const baseUrl = 'https://devapi.haksik.com';
export const baseUrl = 'http://api.haksik.com';